// extracted by mini-css-extract-plugin
export default {"links":"Links_links__FIpT9","link":"Links_link__1lLJI","orgLink":"Links_orgLink__lWrk5","newLink":"Links_newLink__9in8Q","separator":"Links_separator__P0Uzp"};